module.exports = __webpack_public_path__ + "static/img/13.450a795.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/4/eng/13.png
// module id = FT1H
// module chunks = 0